
<template>
  <v-container fluid style="width: 100%; padding: 0">
    <Header />
    <article class="fontscolor">
      <section class="fw-section">
        <div style="background-color: #edf4fe">
          <div class="container fullwidthsec">
            <div class="row" style="padding-top: 70px">
              <div class="col-sm-8">
                <center>
                  <div
                    style="
                      font-size: 26px;
                      font-weight: bold;
                      padding-bottom: 10px;
                    "
                  >
                    Drop Us A Line
                  </div>
                  <div style="font-size: 18px; padding-bottom: 10px">
                    Fill out this quick form and let us know how we can help.
                  </div>
                  <br />

                  <div class="form-group padding-bottom-1x">
                    <div class="row padding-bottom-1x">
                      <div class="col-xs-0 text-left"></div>
                    </div>
                    <label for="email" class="formc">Email</label>
                    <input
                      type="text"
                      v-model="email"
                      name="email"
                      class="form-control"
                      style="background-color: #ffffff; border-color: #c5c5c5"
                      :class="{ 'is-invalid': submitted && !email }"
                      tabindex="110"
                    />
                    <div
                      v-show="submitted && !email"
                      class="subtitle error-msg"
                    >
                      Email is required
                    </div>
                  </div>
                  <div class="form-group padding-bottom-1x">
                    <div class="row padding-bottom-1x">
                      <div class="col-xs-0 text-left"></div>
                    </div>
                    <label for="subject" class="formc">Subject</label>
                    <input
                      type="text"
                      v-model="subject"
                      name="subject"
                      class="form-control"
                      style="background-color: #ffffff; border-color: #c5c5c5"
                      tabindex="110"
                    />
                  </div>
                  <div class="form-group">
                    <div class="row padding-bottom-1x">
                      <div class="col-xs-0 text-left"></div>
                    </div>
                    <div class="formc">Let us know how we can help</div>
                    <textarea
                      cols="40"
                      id="message"
                      name="message"
                      rows="6"
                      v-model="message"
                      style="background-color: #ffffff; border-color: #c5c5c5"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && !message }"
                    ></textarea>
                    <div
                      v-show="submitted && !message"
                      class="subtitle error-msg"
                    >
                      Message is required
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="row padding-bottom-2x"></div>
                    <p class="subtitle error-msg">{{ errorMsg }}</p>
                    <button
                      class="btn btn-ghost1 btn-rounded btn-default waves-effect1 waves-light1 btnl1"
                      type="submit"
                      @click="sendMessage()"
                    >
                      Send message
                    </button>
                  </div>
                </center>
              </div>
              <div class="col-sm-4">
                <div
                  style="
                    font-size: 18px;
                    font-weight: bold;
                    padding-bottom: 10px;
                  "
                >
                  Our details
                </div>

                <div style="display: flex; gap: 10px">
                  <div>
                    <i
                      class="material-icons material-icons-rounded"
                      aria-hidden="true"
                      >location_on</i
                    >
                  </div>
                  <div style="margin-top: -3px">
                    <strong>Poland</strong>
                    <br />Maposcope Marcin Wider<br />43-300 Bielsko-Biala,
                    Lesna 25B
                  </div>
                </div>
                <br />

                <div style="display: flex; gap: 10px">
                  <div>
                    <i
                      class="material-icons material-icons-rounded"
                      aria-hidden="true"
                      >info</i
                    >
                  </div>
                  <div style="margin-top: -3px">
                    Registered in Poland
                    <br />Company Registration Number (NIP) and <br />VAT Number
                    6422450237 <br />‍ <br />For EU purchases, our European VAT
                    number is PL6422450237
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <dialogConfirm ref="confirm"></dialogConfirm>
    </article>

    <Footer />
    <vue-cookies-consent
      backgroundButton="#1972f5"
      borderRadius="5"
      backgroundButtonHover="#3A4F52"
      offsetY="5"
      style="z-index: 1000"
    >
      <template #description>
        <p>
          We use cookies to ensure you get the best experience on our website
          <router-link to="privacy-policy"
            ><span style="color: #0a64eb">Read more</span></router-link
          >
        </p>
      </template>
      <template #button>Accept cookies</template>
    </vue-cookies-consent>
  </v-container>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import VueCookiesConsent from "@norvikit/vue-cookies-consent";
export default {
  components: {
    Header,
    Footer,
    VueCookiesConsent,
  },
  data() {
    return {
      email: "",
      message: "",
      subject: "",
      errorMsg: "",
      //eslint-disable-next-line
      reg: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    };
  },
  computed: {},
  methods: {
    async showInfo() {
      if (
        await this.$refs.confirm.openInfo(
          "Message has been sent",
          "Thank you for your message. We'll get back to you shortly.",
          {
            color: "blue",
          }
        )
      ) {
        // yes
        setTimeout(() => {
          this.$router.push({
            name: "MainHome",
          });
        }, 800); // opóźnienie 0.8 sekundy
      }
    },
    sendMessage() {
      if (this.email == null || this.email == "") {
        this.errorMsg = "Please enter email";
        return;
      } else if (!this.reg.test(this.email)) {
        this.errorMsg = "Please enter correct email";

        return;
      }
      if (
        this.email &&
        this.email.length > 4 &&
        this.message &&
        this.message.length > 3
      ) {
        this.errorMsg = "";
        this.showInfo();
        var message = "Subject: " + this.subject + "\n" + this.message;

        this.$store
          .dispatch("sendMessage", {
            email: this.email,
            message: message,
          })
          .then(() => {});
      } else {
        this.errorMsg = "Email and Message are required";
      }
    },
  },
};
</script>


<style scoped>
a {
  color: red;
}
.error-msg {
  color: red;
  font-weight: bold;
}

/* .wlink a,
a:active,
a:hover {
  color: #ffffff !important;
}
.v-application a {
  color: #ffffff !important;
} */

.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}
.fullwidthsec {
  max-width: 1200px;
}
@media only screen and (max-width: 600px) {
  .fullwidthsec {
    max-width: 350px;
  }
}
</style>